import Vue from 'vue';
import constants from '@/services/constants';
import utilities from '@/services/utilities/utilities';

let state = {
  user: {},
};

let mutations = {
  setUser: function (state, newUser) {
    Vue.set(state, 'user', newUser);

    if (newUser.googleId) {
      localStorage.setItem('previousSignInType', 'google');
    } else if (newUser.twitterId) {
      localStorage.setItem('previousSignInType', 'twitter');
    } else if (newUser.linkedinId) {
      localStorage.setItem('previousSignInType', 'linkedin');
    } else if (newUser.email) {
      localStorage.setItem('previousSignInType', 'email');
    }

    history.replaceState(null, null, ' '); // remove # from url that google sso puts on there
  },
  subscribeToEmail: function (state) {
    state.user.emailOptIn = true;
  },
  unsubscribeFromEmail: function (state) {
    state.user.emailOptIn = false;
  },
  purchasePPT: function (state, version) {
    state.user.auth.push(version);
  },
  upgradeToPremiumVersion: function (state) {
    if (!state.user.auth.includes('basic')) {
      throw new Error('Trying to upgrade when you\'re not on the basic version.');
    }

    let i = state.user.auth.indexOf('basic');

    state.user.auth.splice(i, 1);
    state.user.auth.push('premium');
  },
  onboard: function (state, page) {
    state.user.settings.onboarding[page] = true;
  },
};

let actions = {
  clearUser: function (context) {
    return Vue.axios
      .get(`${process.env.BASE_API_URL}/user/default`)
      .then(function (res) {
        return context.commit('setUser', res.data.user);
      })
      .catch(function () {
        alert('Error. Problem clearing/setting the user. Email contact@sixplusholdem.com for help.');
      })
    ;
  },
};

let getters = {
  loggedIn: function (state) {
    return !!state.user.email;
  },
  authorizedForBasic: function (state, getters) {
    if (!getters.loggedIn) {
      return false;
    }

    if (getters.daysLeftOnFreeTrial > 0) {
      return true;
    }

    if (state.user.auth && (state.user.auth.includes('basic') || state.user.auth.includes('premium'))) {
      return true;
    }

    return false;
  },
  authorizedForPremium: function (state, getters) {
    if (!getters.loggedIn) {
      return false;
    }

    if (getters.daysLeftOnFreeTrial > 0) {
      return true;
    }

    if (state.user.auth && state.user.auth.includes('premium')) {
      return true;
    }

    return false;
  },
  authorizedForShortDeck: function (state, getters) {
    if (!getters.loggedIn) {
      return false;
    }

    if (getters.daysLeftOnFreeTrial > 0) {
      return true;
    }

    if (state.user.auth && state.user.auth.includes('short deck')) {
      return true;
    }

    return false;
  },
  paid: function (state, getters) {
    return state.user.auth && (state.user.auth.includes('basic') || state.user.auth.includes('premium') || state.user.auth.includes('short deck'));
  },
  basicOrPremium: function (state, getters) {
    return state.user.auth && (state.user.auth.includes('basic') || state.user.auth.includes('premium'));
  },
  purchasedShortDeck: function (state, getters) {
    return state.user.auth && state.user.auth.includes('short deck');
  },
  daysSinceSignup: function (state) {
    if (!state.user.created) {
      throw new Error('Trying to figure out daysSinceSignup for someone who isn\'t logged in.');
    }

    return utilities.general.getDaysBetweenDates(state.user.created, new Date());
  },
  daysLeftOnFreeTrial: function (state, getters) {
    const DAYS_FOR_FREE_TRIAL = 14;

    if (!state.user.created) {
      return 0;
    }

    return (DAYS_FOR_FREE_TRIAL - getters.daysSinceSignup).roundToTwoDecimalPlaces();
  },
  handRankings: function (state) {
    let type = state.user.settings.general.handRankings.type;

    if (type !== 'custom') {
      return constants.handRankings[type];
    }

    return state.user.settings.general.handRankings.customHandRankings;
  },
};

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
};

export { state, mutations };



// WEBPACK FOOTER //
// ./src/store/modules/account/account.js